"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "userTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestIdOfLocker",
                type: "uint256",
            },
        ],
        name: "BurnDispute",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "LockerDispute",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldLockers",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newLockers",
                type: "address",
            },
        ],
        name: "NewLockers",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldNetworkFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newNetworkFee",
                type: "uint256",
            },
        ],
        name: "NewNetworkFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldNetworkFeeOracle",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newNetworkFeeOracle",
                type: "address",
            },
        ],
        name: "NewNetworkFeeOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProtocolPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProtocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewProtocolPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRelay",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRelay",
                type: "address",
            },
        ],
        name: "NewRelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldSlasherPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSlasherPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewSlasherPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleBTC",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleBTC",
                type: "address",
            },
        ],
        name: "NewTeleBTC",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldThirdPartyAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newThirdPartyAddress",
                type: "address",
            },
        ],
        name: "NewThirdPartyAddress",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldThirdPartyFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newThirdPartyFee",
                type: "uint256",
            },
        ],
        name: "NewThirdPartyFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldTransferDeadline",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newTransferDeadline",
                type: "uint256",
            },
        ],
        name: "NewTransferDeadline",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTreasury",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTreasury",
                type: "address",
            },
        ],
        name: "NewTreasury",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "userTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestIdOfLocker",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[3]",
                name: "amounts",
                type: "uint256[3]",
            },
            {
                indexed: false,
                internalType: "uint256[4]",
                name: "fees",
                type: "uint256[4]",
            },
        ],
        name: "NewUnwrap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldWrappedNativeToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newWrappedNativeToken",
                type: "address",
            },
        ],
        name: "NewWrappedNativeToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestIdOfLocker",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "bitcoinTxId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bitcoinTxOutputIndex",
                type: "uint256",
            },
        ],
        name: "PaidUnwrap",
        type: "event",
    },
    {
        inputs: [],
        name: "bitcoinFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bitcoinFeeOracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_version",
                type: "bytes4",
            },
            {
                internalType: "bytes",
                name: "_vin",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_vout",
                type: "bytes",
            },
            {
                internalType: "bytes4",
                name: "_locktime",
                type: "bytes4",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_intermediateNodes",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "_burnReqIndexes",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "_voutIndexes",
                type: "uint256[]",
            },
        ],
        name: "burnProof",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "burnRequestCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "burnRequests",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "burntAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isTransferred",
                type: "bool",
            },
            {
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "requestIdOfLocker",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "_indices",
                type: "uint256[]",
            },
        ],
        name: "disputeBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "bytes4[]",
                name: "_versions",
                type: "bytes4[]",
            },
            {
                internalType: "bytes",
                name: "_inputVin",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_inputVout",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_outputVin",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_outputVout",
                type: "bytes",
            },
            {
                internalType: "bytes4[]",
                name: "_locktimes",
                type: "bytes4[]",
            },
            {
                internalType: "bytes",
                name: "_inputIntermediateNodes",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "_indexesAndBlockNumbers",
                type: "uint256[]",
            },
        ],
        name: "disputeLocker",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_transferDeadline",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_slasherPercentageReward",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_networkFee",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_wrappedNativeToken",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "isTransferred",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "isUsedAsBurnProof",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relay",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
        ],
        name: "setLockers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_networkFee",
                type: "uint256",
            },
        ],
        name: "setNetworkFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_networkFeeOracle",
                type: "address",
            },
        ],
        name: "setNetworkFeeOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "setProtocolPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
        ],
        name: "setRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_slasherPercentageReward",
                type: "uint256",
            },
        ],
        name: "setSlasherPercentageReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
        ],
        name: "setStartingBlockNumber",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
        ],
        name: "setTeleBTC",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_thirdPartyAddress",
                type: "address",
            },
        ],
        name: "setThirdPartyAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_thirdPartyFee",
                type: "uint256",
            },
        ],
        name: "setThirdPartyFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_transferDeadline",
                type: "uint256",
            },
        ],
        name: "setTransferDeadline",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wrappedNativeToken",
                type: "address",
            },
        ],
        name: "setWrappedNativeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "slasherPercentageReward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "startingBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_exchangeConnector",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "_amounts",
                type: "uint256[]",
            },
            {
                internalType: "bool",
                name: "_isFixedToken",
                type: "bool",
            },
            {
                internalType: "address[]",
                name: "_path",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "_deadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_userScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_scriptType",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "thirdParty",
                type: "uint256",
            },
        ],
        name: "swapAndUnwrap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "teleBTC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "transferDeadline",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_userScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_scriptType",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "thirdParty",
                type: "uint256",
            },
        ],
        name: "unwrap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wrappedNativeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
//# sourceMappingURL=CCBurnRouter.js.map